"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 * Split selection into regions, and perform a block-wise formatting action for each region.
 */
function blockFormat(editor, callback) {
    editor.focus();
    editor.addUndoSnapshot(function (start, end) {
        var regions = editor.getSelectedRegions();
        regions.forEach(function (region) { return callback(region, start, end); });
        editor.select(start, end);
    }, "Format" /* Format */);
}
exports.default = blockFormat;
//# sourceMappingURL=blockFormat.js.map